import { store } from "../redux/store";

export const isSSOAuthenticated = () => {
    const { apiKey, userAuthenticated } = store.getState().ssoAuth;

    return userAuthenticated && apiKey === sessionStorage.apiKey;
};
